import React from 'react'
import '../assets/scss/main.scss'
import Header from '../components/Header'
import Paper from '../assets/images/nlp-paper.pdf'
import Zine from '../assets/images/zine.pdf'
import { Link } from "gatsby"

const ProjectPage = () => (
    <div>
        <Header />
        <div id="main">
            <section id="one">
                <div class="title"> Projects </div>
                <header className="major">
                    <h2> <Link to="/netsec-exploit">Firefox IonMonkey Exploit</Link></h2>
                </header>
                <p>
                For our final project in CS 378H: Network Security, we had to exploit a bug with no previous POC. We found a bug from 2016 Spidermonkey that we were able to achieve an arbritrary readmem and writemem with. Detailed blog post is linked!
                </p>
            </section>
            <section id="two">
                <header className="major">
                    <h2>Pac-it-up <a href="https://github.com/abbykrish/police-pacs" className="icon fa-github"><span className="label">Github</span></a> </h2>
                </header>
                <p>
                In light of racial injustice and national protest, my friend and I were motivated to work on something to help engage our peers to take different kinds of action. Pac-it-up aggregated police pac campaign spending in Texas and provided and easy way for people to get in touch with their representatives.
                <ul>
                    <li> <a href="http://pac-it-up.com/"> Pac-it-up</a></li>
                </ul>
                </p>
            </section>
            <section id="three">
                <header className="major">
                    <h2>Legal Text Classification <a href="https://github.com/abbykrish/bills-classifier" className="icon fa-github"><span className="label">Github</span></a> </h2>
                </header>
                <p> A self proposed final project for my Natural Language Processing class. This project involved looking into several different ways to make state-of-the-art NLP conventions more performant on legal text classification. It taught me a lot about how much work there is to do for legal ML, and it was a lot of fun!
                    <ul>
                        <li> <a href={Paper}> Paper </a></li>
                    </ul>
                </p>
            </section>
            <section id="four">
                <header className="major">
                    <h2>CTRL-Zine</h2>
                </header>
                <p> My organization, the Texas Civic Tech Project, wrote a zine, or mini magazine about contemporary issues in civic tech that affect students. Reach out to me if you want one, and I will mail one to you, free of charge!
                <ul>
                    <li> <a href={Zine}> Zine </a></li>
                </ul>
                </p>
            </section>

        </div>
    </div>

)


export default ProjectPage